import { AuditLog } from "./AuditLog";
import { motion } from "framer-motion";

export default function AuditLogPage() {
  return (
    <div className="min-h-screen">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
          <AuditLog />
        </motion.div>
      </main>
    </div>
  );
}
